import { render, staticRenderFns } from "./IncommingCall.vue?vue&type=template&id=e943d06a&lang=pug&"
import script from "./IncommingCall.vue?vue&type=script&lang=js&"
export * from "./IncommingCall.vue?vue&type=script&lang=js&"
import style0 from "./IncommingCall.vue?vue&type=style&index=0&id=e943d06a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports